/* PepoStore — custom scripts (ps-*) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.ps-reveal, .ps-stagger, .ps-rating');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('ps-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ps-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { if (!el.classList.contains('ps-visible')) io.observe(el); });
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-ps-gallery]');
    if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = '1';
    var slides = gallery.querySelectorAll('.ps-gallery__main img');
    var thumbs = gallery.querySelectorAll('.ps-gallery__thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = gallery.querySelector('.ps-gallery__nav--prev');
    var next = gallery.querySelector('.ps-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    var main = gallery.querySelector('.ps-gallery__main');
    var startX = null;
    main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
    gallery.showMediaById = function (id) {
      slides.forEach(function (s, n) { if (s.dataset.mediaId === String(id)) show(n); });
    };
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initVariants(root) {
    var buy = root.querySelector('[data-ps-buy]');
    if (!buy || buy.dataset.ready) return;
    buy.dataset.ready = '1';
    var dataEl = buy.querySelector('[data-ps-variants]');
    var idInputs = buy.querySelectorAll('input[name="id"]');
    var qtyInput = buy.querySelector('[data-ps-qty]');
    if (qtyInput) {
      buy.querySelectorAll('[data-ps-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          v += b.dataset.psQtyBtn === 'plus' ? 1 : -1;
          qtyInput.value = Math.max(1, v);
          buy.querySelectorAll('input[name="quantity"][type="hidden"]').forEach(function (h) { h.value = qtyInput.value; });
        });
      });
      qtyInput.addEventListener('change', function () {
        buy.querySelectorAll('input[name="quantity"][type="hidden"]').forEach(function (h) { h.value = qtyInput.value; });
      });
    }
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = buy.dataset.moneyFormat;
    var fieldsets = buy.querySelectorAll('.ps-option');
    var addBtns = document.querySelectorAll('[data-ps-add]');
    function update() {
      var selected = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
        var label = fs.querySelector('legend span');
        if (label && checked) label.textContent = checked.value;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      var nowEl = buy.querySelector('[data-ps-price-now]');
      var wasEl = buy.querySelector('[data-ps-price-was]');
      var saveEl = buy.querySelector('[data-ps-save]');
      if (!variant) {
        addBtns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); var s = b.querySelector('span'); if (s) s.textContent = b.dataset.unavailable; });
        return;
      }
      idInputs.forEach(function (i) { i.value = variant.id; });
      if (nowEl) nowEl.textContent = formatMoney(variant.price, moneyFormat);
      if (wasEl) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        wasEl.textContent = onSale ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        wasEl.hidden = !onSale;
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = saveEl.dataset.label.replace('[amount]', formatMoney(variant.compare_at_price - variant.price, moneyFormat));
        }
      }
      addBtns.forEach(function (b) {
        var s = b.querySelector('span');
        if (variant.available) { b.removeAttribute('disabled'); if (s) s.textContent = b.dataset.add; }
        else { b.setAttribute('disabled', 'disabled'); if (s) s.textContent = b.dataset.soldout; }
      });
      var gallery = root.querySelector('[data-ps-gallery]');
      if (variant.featured_media && gallery && gallery.showMediaById) gallery.showMediaById(variant.featured_media.id);
      if (buy.dataset.updateUrl === 'true' && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-ps-sticky]');
    var anchor = root.querySelector('[data-ps-sticky-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
    var btn = sticky.querySelector('[data-ps-sticky-btn]');
    if (btn) btn.addEventListener('click', function () {
      var main = root.querySelector('[data-ps-add]');
      if (main && !main.disabled) main.click();
      else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function initTimeline(root) {
    var tl = root.querySelector('[data-ps-timeline]');
    if (!tl) return;
    function addBiz(date, n) {
      var d = new Date(date.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    }
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var range = function (a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '–' + b.getDate() : fmt(a) + ' – ' + fmt(b); };
    var now = new Date();
    var sMin = +tl.dataset.shipMin, sMax = +tl.dataset.shipMax, dMin = +tl.dataset.delMin, dMax = +tl.dataset.delMax;
    var set = function (k, v) { var el = tl.querySelector('[data-ps-tl="' + k + '"]'); if (el) el.textContent = v; };
    set('ordered', fmt(now));
    set('shipped', sMin === sMax ? fmt(addBiz(now, sMin)) : range(addBiz(now, sMin), addBiz(now, sMax)));
    set('delivered', range(addBiz(now, sMin + dMin), addBiz(now, sMax + dMax)));
  }

  function initAll(root) {
    initTimeline(root);
    root = root || document;
    initReveal();
    initGallery(root);
    initVariants(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
